import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Button from "../ui/Button";

function formatCurrency(value) {
  if (value == null || value === "") {
    return "—";
  }
  const normalized = String(value).replace(/,/g, "");
  const amount = parseFloat(normalized);
  if (Number.isNaN(amount)) {
    return `$${value}`;
  }
  return amount.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
  });
}

function formatBarcodeSerial(value) {
  if (value == null || value === "") {
    return "—";
  }
  return String(value);
}

export default function InventoryRawMaterialSubTable(props) {
  const { data, onUpdateReceivingItemStock, onPromote } = props;

  const onCellEditComplete = (e) => {
    const { rowData, newValue, field, originalEvent: event } = e;

    switch (field) {
      default:
        if (newValue.trim().length > 0) {
          const oldItemCost = rowData.total_cost;
          const newItemCost = (
            parseFloat(newValue) * parseFloat(rowData.unit_cost)
          ).toFixed(2);

          rowData[field] = parseFloat(newValue).toFixed(2);
          rowData.total_cost = newItemCost;
          onUpdateReceivingItemStock(
            rowData.id,
            parseFloat(newValue),
            rowData.old_in_stock,
            rowData.parent_index,
            oldItemCost,
            newItemCost,
          );
        } else {
          event.preventDefault();
        }
        break;
    }
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
        className="w-full min-h-9 rounded-lg border border-[#E2E8F0] px-2 py-1 text-sm"
      />
    );
  };

  const promoteActionTemplate = (row) => {
    const inStock = parseFloat(String(row.in_stock).replace(/,/g, ""));
    if (!Number.isFinite(inStock) || inStock <= 0) {
      return null;
    }

    return (
      <Button
        type="button"
        variant="secondary"
        size="sm"
        onClick={() => onPromote?.(row.id)}
      >
        Promote to sellable stock
      </Button>
    );
  };

  return (
    <div className="operational-embedded-table overflow-hidden rounded-lg border border-[#E2E8F0] bg-white">
      <DataTable
        value={data.subItems}
        className="p-datatable-sm text-sm"
        editMode="cell"
        dataKey="id"
      >
        <Column
          field="supplier_name"
          header="Supplier Name"
          style={{ minWidth: "10rem" }}
        />
        <Column
          field="invoice_number"
          header="Invoice Number"
          style={{ minWidth: "8rem" }}
        />
        <Column
          field="product_name"
          header="Product Name"
          style={{ minWidth: "12rem" }}
          bodyClassName="font-medium text-[#0F172A]"
        />
        <Column
          header="Serial"
          body={(row) => (
            <span className="tabular-nums font-mono text-[#0F172A]">
              {formatBarcodeSerial(row.barcode_serial)}
            </span>
          )}
          style={{ minWidth: "8rem" }}
        />
        <Column
          header="Unit Cost"
          body={(row) => (
            <span className="tabular-nums">
              {formatCurrency(row.unit_cost)}
            </span>
          )}
          style={{ minWidth: "7rem", textAlign: "right" }}
          bodyClassName="text-right tabular-nums"
        />
        <Column
          field="in_stock"
          header="Total Unit"
          editor={(options) => textEditor(options)}
          onCellEditComplete={onCellEditComplete}
          style={{ minWidth: "7rem", textAlign: "right" }}
          bodyClassName="text-right tabular-nums"
        />
        <Column
          header="Total Cost"
          body={(row) => (
            <span className="tabular-nums font-medium text-[#0F172A]">
              {formatCurrency(row.total_cost)}
            </span>
          )}
          style={{ minWidth: "7rem", textAlign: "right" }}
          bodyClassName="text-right tabular-nums"
        />
        <Column
          header="Actions"
          body={promoteActionTemplate}
          style={{ minWidth: "12rem" }}
        />
      </DataTable>
    </div>
  );
}
